/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Pending Students</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Email</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Birthday</th>
              <th scope="col">School</th>
              <th scope="col">Grade</th>
              <th scope="col">City</th>
              <th scope="col">Guardian Name</th>
              <th scope="col">Guardian Email</th>
              <th scope="col">Guardian Phone</th>
              <th scope="col">Points</th>
              <th scope="col">Take Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ student.email }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.birthday }}</td>
              <td>{{ student.school }}</td>
              <td>{{ student.grade }}</td>
              <td>{{ student.city }}</td>
              <td>{{ student.parent_first_name }} {{student.parent_last_name}}</td>
              <td>{{ student.parent_email }}</td>
              <td>{{ student.parent_phone_number }}</td>
              <td>{{ student.points }}</td>
              <td>
                <button
                  class="btn btn-primary btn-sm btn-block"
                  v-if="student.status=='pending'"
                  @click="activate(student._id)"
                >
                  Activate
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";


export default {
  name: "PendingStudents",
  components: {
 
  },
  data() {
    return {
      modalTeacher: false,
      students: [],
      currentStudentId: "",
      teachers: [],
      teacher: "",
      currentTeacherName: "",
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },
  methods: {
    activate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Activating Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/activate", {}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Activated Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    deactivate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Disabling Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/deactivate", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Disabled Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Students Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/pending-students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.students = response.data.data.students;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
